import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SectoresProductivosService } from 'src/app/services/sectores-productivos.service';

import {MatSort} from '@angular/material/sort';

@Component({
  selector: 'estandares',
  templateUrl: './estandares.component.html',
  styleUrls: ['./estandares.component.css']
})
export class EstandaresComponent implements OnInit {


  displayedColumns: string[] = ['id', 'descripcion'];
  dataSource: any;
  @Output()
  sectorEsById = new EventEmitter<any>();
  @Output()
  backTo = new EventEmitter<number>();

  @Input() idSector:number;  
  @Input() title: string; 
  @Input() padre: number;

  idselectorRes:number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input() estandarDes: string;

  constructor(private service: SectoresProductivosService) {
    this.estandarDes="";
  }

  ngOnInit(): void {
    this.getEstandares();
    this.idselectorRes=this.idSector;
  }

  async getEstandares() {
    if(this.estandarDes.trim()===""){
      this.estandarDes='NA';
    }
    console.log(this.estandarDes)
    try {
      const get = await this.service.getEstandaresById(this.idSector, this.estandarDes);      
      this.dataSource = new MatTableDataSource<any>(get)
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } catch (error) {
      console.log(error);
    }
  }

  sectorByID(element) {
    let json = {
      element: element,
      padre: this.padre,
      titlePadre: this.title,
      idselectorRes:this.idselectorRes
    
    }
    this.sectorEsById.emit(json);
  }

  back(){
    this.backTo.emit(this.padre);
  }
  home(){
    window.location.reload();
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
